import { action, observable } from 'mobx'
import http from '../service/http'

class Store {
  /**当天的预订 */
  @observable todayBookings = {}
  @observable shortCuts = null
  /**
   * 获取首页banner
   *
   */
  @action
  getHomeBanners({ region = 'shanghai' }, isMobile, genre = false) {
    return new Promise((resolve, reject) => {
      http
        .get(`/public/regions/${region}/app_banners`, {
          params: {
            platform: isMobile ? 'mobile' : 'desktop',
            genre: genre ? 'vip_benefits' : ''
          }
        })
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  /**
   * 获取首页shortcuts
   *
   */
  @action
  getHomeShortCuts({ region = 'shanghai', project }) {
    return new Promise((resolve, reject) => {
      if (this.shortCuts) {
        resolve(this.shortCuts)
      } else {
        http
          .get(`/public/shortcuts`, {
            params: {
              region,
              project: project || 'diningcity'
            },
            headers: {
              'accept-version': '2'
            }
          })
          .then(({ data }) => {
            // data = data.concat(data.concat(data))
            resolve(data)
          })
          .catch(error => {
            reject(error)
          })
      }
    })
  }

  /**
   * 获取Adv pop up
   *
   */
  @action
    getHomeAdvPopup({ region, lang, private_token }) {
    return new Promise((resolve, reject) => {
      http
        .get(`/public/advertisement_pops`, {
          headers: {
            'access-token-member': private_token
          },

          params: {
            api_key: 'cgecegcegcc',
            region,
            lang,
            platform: 'web'
          }
        })
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  /**
   * 获取today bookings
   *
   */
  @action
  getTodayBookings() {
    return new Promise((resolve, reject) => {
      http
        .get(`/member/bookings/today`)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  /**
   * 获取Collections
   *
   */
  @action
  getHomeCollections(params) {
    return new Promise((resolve, reject) => {
      http
        .get(`/public/regions/${params.region}/groups/web_home`, {
          params,
          headers: {
            'accept-version': '2'
          }
        })
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  /**
   * 获取shortLink详情
   *
   */
  @action
  getWebviewSkip(link) {
    return new Promise((resolve, reject) => {
      http
        .get('/public/deeplinks/webview_skip', {
          params: {
            link
          }
        })
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  /**
   * 获取当前活动
   *
   */
  @action
  getCurrenEvent(region) {
    return new Promise((resolve, reject) => {
      http
        .get(`/public/regions/${region}/project_configs/current_event`)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  /**
   * 获取eventBlock logo
   *
   */
  @action
  getEventBlockLogo(project) {
    return new Promise((resolve, reject) => {
      http
        .get(`/public/projects/${project}/imgs/logo_horizontal`, {
          headers: {
            lang: 'en'
          }
        })
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {})
    })
  }
  // 获取活动倒计时相关信息
  @action
  getBookingInfo(project) {
    return new Promise((resolve, reject) => {
      http
        .get(`/public/project_configs/${project}/booking_info`)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {})
    })
  }

  // 获取主要合作伙伴
  @action
  getSponsors(region, project) {
    const host = process.env.REACT_APP_MODE === 'PRODUTION' ? 'restaurantweek.diningcity.cn' : 'rieslingweeks.diningcity.cn'
    return new Promise((resolve, reject) => {
      http
        .get(`https://${host}/api/v1/cities/${region}/sponsor_categories`, {
          headers: {
            Authorization: 'Basic bW9iaWxlX2NsaWVudDplYjMyMzQyNzA1ZGU0ZjE3ODRhOWRiMTUzNzVmM2FhMw'
          },
          params: {
            project,
            on_extended: true
          }
        })
        .then(({ data }) => {
          const [{ sponsors }] = data
          resolve(sponsors || [])
        })
        .catch(error => {})
    })
  }
  // 获取banner链接
  @action
  getBanner(project, name = 'dc_homepage_banner_web') {
    return new Promise((resolve, reject) => {
      http
        .get(`/public/projects/${project}/imgs/${name}`)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {})
    })
  }

  // 获取shortCuts链接
  @action
  getShortCuts(region, project, isMobile) {
    return new Promise((resolve, reject) => {
      http
        .get(`/public/shortcuts`, {
          params: {
            region,
            platform: isMobile ? 'mobile' : 'desktop',
            project,
            display_in: 'dc'
          },
          headers: {
            'accept-version': '2'
          }
        })
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {})
    })
  }

  @action
  getContentBlock(region, project, isMobile) {
    return new Promise((resolve, reject) => {
      http
        .get(`/public/regions/${region}/content_blocks`, {
          params: {
            platform: isMobile ? 'web_mobile' : 'web_desktop',
            project,
            display_in: 'dc'
          },
          headers: {
            'accept-version': '2'
          }
        })
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {})
    })
  }
}

export default new Store()
